module.exports = __webpack_public_path__ + "img/airtime.e5f1c1fc.jpg";